import { render, staticRenderFns } from "./actividad-vinculacion-ars.vue?vue&type=template&id=ae664f66&"
import script from "./actividad-vinculacion-ars.component.ts?vue&type=script&lang=ts&"
export * from "./actividad-vinculacion-ars.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports